export default __webpack_public_path__ + "static/media/ALG.0de75eb9.svg";